import { render, staticRenderFns } from "./AddPodcast.vue?vue&type=template&id=2f67710c"
import script from "./AddPodcast.vue?vue&type=script&lang=js"
export * from "./AddPodcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports